import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';

import * as actionTypes from 'web-app/react/constants/action-types';
import * as ChildActions from 'web-app/react/entities/children/actions';
import {makeReducer, match} from 'web-app/util/redux';

import permissionsReducer from './permission-list/reducer';
import groupMoveReducer from './group-move/reducer';
import groupsReducer from './groups/reducer';
import childPlansReducer from './plans-and-invoices/reducer';
import childContactsReducer from './contacts/reducer';
import healthReducer from './health/reducer';
import sensitiveInformationReducer from './sensitive-information/reducer';
import kibig from './kibig/reducer';
import keyWorkerReducer from './key-worker/reducer';
import aboutReducer from './about/reducer';
import tagsReducer from './tags/reducer';
import basicInfo from './basic-info/reducer';
import registration, {type ChildProfileRegistrationState} from './registration/reducer';
import moveSetting from './move-setting/reducer';
import holidayRSVP from './holiday-rsvp/reducer';
import leaveRegistration from './leave-registration/reducer';
import activity from './activity/reducer';
import learningJourney from './learning-journey/reducer';
import childModal from './child-modal/reducer';
import editBillPayersModal from './plans-and-invoices/edit-bill-payers-modal/reducer';

const updatingPermissions = handleActions(
    {
        [actionTypes.CHILD_PERMISSION_FETCH]: () => true,
        [actionTypes.CHILD_PERMISSION_FETCH_SUCCESS]: () => false,
        [actionTypes.CHILD_PERMISSION_FETCH_ERROR]: () => false,
    },
    false,
);

const childId = makeReducer<string | null>(
    [match(ChildActions.emberFetchSuccess, (state, action) => action.payload.child.childId)],
    null,
);

const institutionCountry = makeReducer<string>(
    [
        match(ChildActions.emberFetchSuccess, (state, {payload}) =>
            payload.institution ? payload.institution.country : state,
        ),
    ],
    '',
);

const childProfile = combineReducers<{
    learningJourney: any;
    activity: any;
    leaveRegistration: any;
    childId: any;
    updatingPermissions: any;
    institutionCountry: any;
    kibig: any;
    basicInfo: any;
    moveSetting: any;
    holidayRSVP: any;
    groupMove: any;
    groups: any;
    childContacts: any;
    permissions: any;
    childPlans: any;
    tags: any;
    about: any;
    health: any;
    sensitive: any;
    keyWorker: any;
    registration: ChildProfileRegistrationState;
    childModal: any;
    editBillPayersModal: any;
}>({
    learningJourney,
    activity,
    leaveRegistration,
    childId,
    updatingPermissions,
    institutionCountry,
    kibig,
    basicInfo,
    moveSetting,
    holidayRSVP,
    groupMove: groupMoveReducer,
    groups: groupsReducer,
    childContacts: childContactsReducer,
    permissions: permissionsReducer,
    childPlans: childPlansReducer,
    tags: tagsReducer,
    about: aboutReducer,
    health: healthReducer,
    sensitive: sensitiveInformationReducer,
    keyWorker: keyWorkerReducer,
    registration,
    childModal,
    editBillPayersModal,
});

export default childProfile;
